'use es6';

import { Record, Set as ImmutableSet } from 'immutable';
import { AdWordsChannelType, AdWordsStatusMap } from '../../lib/Constants';
import AdWordsBiddingStrategyConfigurationEntityRecord from './AdWordsBiddingStrategyConfigurationEntityRecord';
import AdWordsNetworkSettingsRecord from './AdWordsNetworkSettingsRecord';
import AdWordsDailyBudgetEntityRecord from './AdWordsDailyBudgetEntityRecord';
const AdWordsGeneralSettingsRecord = Record({
  targetingSetting: null
}); // https://git.hubteam.com/HubSpot/Ads/blob/master/AdsBase/src/main/java/com/hubspot/ads/data/adwords/AbstractAdWordsCampaignView.java

export default Record({
  id: null,
  name: '',
  status: AdWordsStatusMap.ENABLED,
  trackingUrlTemplate: null,
  adGroups: ImmutableSet(),
  // List of IDs
  hsCampaignUtm: null,
  biddingStrategyConfiguration: new AdWordsBiddingStrategyConfigurationEntityRecord({}),
  conversionOptimizerEligibility: null,
  channelType: AdWordsChannelType.SEARCH,
  channelSubType: null,
  networkSetting: new AdWordsNetworkSettingsRecord({
    targetGoogleSearch: true,
    targetSearchNetwork: false,
    targetContentNetwork: false
  }),
  generalSettings: new AdWordsGeneralSettingsRecord(),
  locationProximities: ImmutableSet(),
  budget: new AdWordsDailyBudgetEntityRecord({}) // AbstractDailyBudgetView

});